module.exports = __webpack_public_path__ + "nr.7b85674c8218385e93bf.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/nr.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/nr.svg
// module chunks = styles